import axios from 'axios'
import {API_ENDPOINTS} from '../../../constants/apiConstants'

/**
 * Get all settings for the current user
 */
export const getAllSettings = async () => {
  try {
    const response = await axios.get(API_ENDPOINTS.GET_ALL_SETTINGS())
    return response.data
  } catch (error) {
    console.error('Error fetching settings:', error)
    throw error
  }
}

/**
 * Get all accessible settings (including team and public)
 */
export const getAccessibleSettings = async () => {
  try {
    const response = await axios.get(API_ENDPOINTS.GET_ACCESSIBLE_SETTINGS())
    return response.data
  } catch (error) {
    console.error('Error fetching accessible settings:', error)
    throw error
  }
}

/**
 * Get a specific setting by key
 * @param {string} key - The setting key
 */
export const getSetting = async (key) => {
  try {
    const response = await axios.get(API_ENDPOINTS.GET_SETTING(key))
    return response.data
  } catch (error) {
    console.error(`Error fetching setting '${key}':`, error)
    throw error
  }
}

/**
 * Update or create a setting
 * @param {string} key - The setting key
 * @param {any} value - The setting value
 * @param {Object} options - Additional options
 * @param {string} [options.description] - Optional description of the setting
 * @param {boolean} [options.isGlobal] - Whether this is a global setting
 * @param {string} [options.accessScope] - Who can access this setting ('private', 'team', 'public')
 */
export const updateSetting = async (key, value, options = {}) => {
  try {
    const response = await axios.put(API_ENDPOINTS.UPDATE_SETTING(key), {
      value,
      ...options,
    })
    return response.data
  } catch (error) {
    console.error(`Error updating setting '${key}':`, error)
    throw error
  }
}

/**
 * Delete a setting
 * @param {string} key - The setting key to delete
 */
export const deleteSetting = async (key) => {
  try {
    const response = await axios.delete(API_ENDPOINTS.DELETE_SETTING(key))
    return response.data
  } catch (error) {
    console.error(`Error deleting setting '${key}':`, error)
    throw error
  }
}
